/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Änderung eines einzelnen Feldes eines Railium-Einsatzes
 * @export
 * @interface RailiumFeldAenderung
 */
export interface RailiumFeldAenderung {
    /**
     * Name des Feldes
     * @type {string}
     * @memberof RailiumFeldAenderung
     */
    feld: string;
    /**
     * Wert im vorherigen Umsatz-Historieneintrag
     * @type {string}
     * @memberof RailiumFeldAenderung
     */
    vorher?: string;
    /**
     * Wert im aktuellen Umsatz-Historieneintrag
     * @type {string}
     * @memberof RailiumFeldAenderung
     */
    nachher?: string;
}

/**
 * Check if a given object implements the RailiumFeldAenderung interface.
 */
export function instanceOfRailiumFeldAenderung(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "feld" in value;

    return isInstance;
}

export function RailiumFeldAenderungFromJSON(json: any): RailiumFeldAenderung {
    return RailiumFeldAenderungFromJSONTyped(json, false);
}

export function RailiumFeldAenderungFromJSONTyped(json: any, ignoreDiscriminator: boolean): RailiumFeldAenderung {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'feld': json['feld'],
        'vorher': !exists(json, 'vorher') ? undefined : json['vorher'],
        'nachher': !exists(json, 'nachher') ? undefined : json['nachher'],
    };
}

export function RailiumFeldAenderungToJSON(value?: RailiumFeldAenderung | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'feld': value.feld,
        'vorher': value.vorher,
        'nachher': value.nachher,
    };
}

